import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef, MatDialog, MatSnackBar, MAT_DIALOG_DATA } from '@angular/material';
import { Course } from 'src/app/interfaces/course';
import { CourseService } from '../../services/course.service';
import { DeleteConfirmModalComponent } from '../../commons/delete-confirm-modal/delete-confirm-modal.component';
import { Observable } from 'rxjs';
import { CourseChangeConfirmComponent } from '../course-change-confirm/course-change-confirm.component';


@Component({
  selector: 'app-edit-course-modal',
  templateUrl: './edit-course-modal.component.html',
  styleUrls: ['./edit-course-modal.component.scss']
})
export class EditCourseModalComponent implements OnInit {
  loading: Boolean = false;
  courseData;
  error: string;
  newColor: any;
  rgba: any;
  always: any;
  trackHours = false;
  hasExam: boolean
  isQuizRelease: boolean
  ngOnInit() {
    this.data.color ? this.newColor = JSON.parse(JSON.stringify(this.data.color)) : this.newColor = "#000000";

    console.log("DATA = ", this.data);
    this.courseData = JSON.parse(JSON.stringify(this.data));
    if (this.courseData && this.courseData.trackHours) {
      this.trackHours = this.courseData.trackHours
      this.cd.detectChanges()
    }
    console.table(this.courseData)

    if (this.courseData && this.courseData.hasExam) {
      this.hasExam = this.courseData.hasExam
      this.cd.detectChanges()
    }
    if (this.courseData && this.courseData.isQuizRelease) {
      this.isQuizRelease = this.courseData.isQuizRelease
      this.cd.detectChanges()
    }
    // console.table(this.courseData)
  }
  constructor(public dialog: MatDialog, public dialogRef: MatDialogRef<Course>, @Inject(MAT_DIALOG_DATA) public data: any, public _courseService: CourseService, public cd: ChangeDetectorRef) {
    // NO DEFINITION
  }
  validate(data) {
    console.log("Validating ", data/*, this.courseData*/);
    console.log("data.duration == null || data.duration == undefined ", data.duration == null || data.duration == undefined/*, this.courseData*/, data.duration);
    console.log("!data.title ", data.title == ''/*, this.courseData*/, data.title);
    console.log("data.exams == null || data.exams == undefined ", data.exams == null || data.exams == undefined/*, this.courseData*/, data.exams);
    console.log("!data.color ", !data.color/*, this.courseData*/);

    if (data.duration == null || data.duration == undefined) return false;
    if (!data.title) return false;
    // if (!data.type) return false;
    if (data.exams == null || data.exams == undefined) return false;
    if (!data.color) return false;
  }

  typeChanged(event) {
    if (event.value) {
      this.openDialog(CourseChangeConfirmComponent, event.value).subscribe(res => {
        console.log('res', res)
        if (res == 'yes') {
          console.log("event", event);
          this.data['type'] = event.value
        }
        else {
          if (event.value == 'Level2') {
            this.courseData.type = 'Level3'
          }
          else {
            this.courseData.type = 'Level2'
          }

        }
      })
    }
  }

  doSubmit() {
    console.log("Submit ", this.courseData);
    this.courseData.color = this.newColor
    this.courseData.hasExam = this.hasExam
    this.isQuizRelease = this.isQuizRelease
    this.courseData.trackHours = this.trackHours
    // if (this.courseData.title == '' || this.courseData.title == null) {
    //   this.error = "Course title required!"
    //   return
    // }
    // else if (this.courseData.duration == '' || this.courseData.duration == null) {
    //   this.error = "Course duration required!"
    //   return
    // }
    if (this.validate(this.courseData) == false) {
      console.log("RETURNING", this.validate(this.courseData));
      this.loading = false
      return;
    }
    /*else{
      console.log("RETURNING", this.validate(this.courseData));
    }*/
    else {


      // Do Submit
      this.loading = true;
      let course = {
        _id: this.courseData._id,
        title: this.courseData.title,
        duration: this.courseData.duration,
        color: this.courseData.color,
        type: this.courseData.type,
        exams: this.courseData.exams,
        courseMetaId: this.courseData.courseMetaId,
        trackHours: this.trackHours,
        hasExam: this.hasExam,
        isQuizRelease: this.isQuizRelease
      }

      // if (this.courseData.portfolioId) course['portfolioId'] = this.courseData.portfolioId
      this._courseService.editCourse(course).subscribe(() => {
        this.courseData.color = this.courseData.color
        this.data = this.courseData;
        this.loading = false;
        this.closoeDialog({
          action: 'edit',
          result: 'success',
          data: this.courseData
        });
      }, err => {
        // alert("Error editing course.")

        this.loading = false;
        this.closoeDialog({
          action: 'edit',
          result: 'err',
          data: err
        });
      });
    }

  }

  delete() {
    console.warn("DELETING ", this.data._id);
    this.openDialog(DeleteConfirmModalComponent, "Course").subscribe(confirm => {
      if (confirm == '') return
      else if (confirm == 'yes') {
        this._courseService.deleteCourse(this.courseData._id).subscribe(courses => {
          this.data = courses;
          this.loading = false;
          this.closoeDialog({
            action: 'delete',
            result: 'success',
            data: this.data
          });
        }, err => {
          // alert(err)
          console.log("ERROR IN COURSE DELETE", err)
          this.loading = false;
          this.closoeDialog({
            action: 'delete',
            result: 'err',
            data: err
          });
        });
      }
    })
  }


  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, { data });
    return dialogRef.afterClosed();
  }

  closoeDialog(result) {
    this.dialogRef.close(result);
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  /*Use less function*/
  numberofExamChanged() {

  }

}
